import { render } from "./PackageDashboardComponent.vue?vue&type=template&id=a2697372"
import script from "./PackageDashboardComponent.vue?vue&type=script&lang=js"
export * from "./PackageDashboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__